
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/events/live",
      function () {
        return require("private-next-pages/events/live.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/events/live"])
      });
    }
  